import { Key, useState } from "react";
import { createModel } from "hox";
import { useSessionStorageState } from "ahooks";
import { ICustomerAccountSummary } from "../../../AccountTypes";
import { accountService } from "../../../AccountService";
import useNavModel from "@/model/navModel";
import { IMdOrgDetail, orgService } from "../../../../base/org/orgService";
import { ITreeData } from "../../../../base/dict/dictModel";
import { OptionDsType } from "@/types/FmsTypes";
import { useGlobalModel } from "@/model/globalModel";
import { ResourceAuthEnum } from "@/types/FmsResourceAuthEnum";
import { IMdDictFields } from "@/views/base/dict/dictService";
import { bigNumber } from "@/utils/utils";

export enum ActionTypeEnum {
    ACCOUNT,
    ADJUST_LIST,
    RECHARGE_LIST,
    TRANSFER_LIst,
    BILL_LIST,
    WRITEOFF_LIST,
    LOG_LIST,
    SYSTEM_RECEIVABLE,
    NULL
}

type labelsType = {
    [proppName: string]: string;
}

export const useDetailModel = createModel(function () {
    const { user: { shopCode } } = useGlobalModel();
    const [customerCode, setCustomerCode] = useSessionStorageState<string[]>("accountShop.detail.customerMergerCodes", []);
    const [customerOptions, setCustomerOptions] = useSessionStorageState<OptionDsType[]>("accountShop.detail.customerMergerOptions", []);

    const [actionType, setActionType] = useSessionStorageState<ActionTypeEnum>("customerMerger.detail.type", ActionTypeEnum.NULL) // 选中展示模块
    const [customer, setCustomer] = useState<ICustomerAccountSummary>({ key: "" });
    const { closeNav } = useNavModel(() => []);

    const [orgDs, setOrgDs] = useState<ITreeData<IMdOrgDetail>[]>();
    const [beDs, setBeDs] = useState<OptionDsType[]>();
    const [appDs, setAppDs] = useState<OptionDsType[]>();
    const [payMethodLabels, setPayMethodLabels] = useState<labelsType>({});
    const [payMethodDs, setPayMethodDs] = useState<ITreeData<IMdDictFields>[]>();
    const [accountTypeDs, setAccountType] = useState<OptionDsType[]>([]);


    const loadSummaryData = (code?: Key) => {
        if (customerCode) {
            accountService
                .customerSummaryAll({ partnerCodes: customerCode, shopCode})
                .then(({ retData }) => {
                    let cus: ICustomerAccountSummary = { key: "" }
                    retData.forEach((item,index) => {
                        if(index === 0){
                            cus = item 
                        }else{
                            cus.name = `${cus.name}/${item.name}`
                            cus.totalAvailableAmount =bigNumber.add(cus.totalAvailableAmount??0,item.totalAvailableAmount??0)
                            cus.totalDebtAmount = bigNumber.add(cus.totalDebtAmount??0,item.totalDebtAmount??0)
                        }
                    })
                    setCustomer(cus ?? {});
                });
        }
    }

    return {
        appDs,
        orgDs,
        beDs,
        payMethodDs,
        payMethodLabels,
        actionType,
        customerCode,
        customer,
        accountTypeDs, customerOptions, setCustomerOptions,setAccountType,
        setActionType,
        setCustomerCode,
        loadSummaryData,
        setOrgDs,
        setBeDs,
        setPayMethodDs,
        setPayMethodLabels,
        setAppDs,
        closeNav,
    }
});
